module.exports = __webpack_public_path__ + "static/media/listing-page-bali.689e488c.jpg";